import Cookies from 'js-cookie';

const authTokenName = import.meta.env.VITE_AUTH_TOKEN_NAME;
export default {
  getCookieAuthData: () => {
    try {
      const authData = Cookies.get(authTokenName);
      if (authData === null) {
        return undefined;
      }
      return JSON.parse(authData);
    } catch {
      return undefined;
    }
  },
  setCookieAuthData: data => {
    try {
      const JSONString = JSON.stringify(data);
      Cookies.set(authTokenName, JSONString, { expires: 365 });
      return JSONString;
    } catch {
      return undefined;
    }
  },
  removeCookieAuthData: () => {
    Cookies.remove(authTokenName);
    return true;
  },
};
